define(['jquery'], function ($) {

  $.fn.pkoCheckbox = function (_options) {

    var options = $.extend({}, $.fn.pkoCheckbox.defaults, _options),
      init = function (elem) {
        var $elem = $(elem);

        if ($elem.prev().length < 1 && !$elem.prev().hasClass(options.classCheckbox)) {
          $elem.before('<span class="' + options.classCheckbox + '"></span>');
        }

        $elem.addClass(options.classInput);

        isChecked($elem);
      },
      events = function (elem) {
        var $elem = $(elem);

        $elem.on('click', function () {
          isChecked($elem);
        });

        // $elem.on( 'focus', function( ) {
        //     $( this ).prev( 'span.' + options.classCheckbox ).addClass( 'focus' );// 2DO
        // } );

        // $elem.on( 'blur', function( ) {
        //     $( this ).prev( 'span.' + options.classCheckbox ).removeClass( 'focus' );// 2DO
        // } );

        $elem.on('switch.check', function (event, mode) {
          if (mode === undefined) {
            mode = true;
          }
          $elem.prop('checked', mode);
          if (mode) {
            $elem.prev('.' + options.classCheckbox).addClass('checked');
          } else {
            $elem.prev('.' + options.classCheckbox).removeClass('checked');
          }
        });

      },
      isChecked = function (_this) {
        if (_this.is(':checked')) {
          _this.prev('.' + options.classCheckbox).addClass('checked');
        } else {
          _this.prev('.' + options.classCheckbox).removeClass('checked');
        }
        // if ( _this.is( ':disabled' ) ) {
        //     _this.prev( '.' + options.classCheckbox ).addClass( 'disabled' );// 2DO
        // } else {
        //     _this.prev( '.' + options.classCheckbox ).removeClass( 'disabled' );// 2DO
        // }
      };

    return this.each(function () {
      init(this);
      events(this);
    });

  };

  $.fn.pkoCheckbox.defaults = {
    classCheckbox: 'form-checkbox',
    classInput: 'form-checkbox-input'
  };

});



// WEBPACK FOOTER //
// ./_front/_inteligo/js/lib/jquery.pkoCheckbox.js